import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ServiceBillingDetail } from './service-billing-detail.model';
import * as ServiceBillingDetailActions from './service-billing-detail.actions';

export const serviceBillingDetailsFeatureKey = 'serviceBillingDetails';

export interface State extends EntityState<ServiceBillingDetail> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceBillingDetail> = createEntityAdapter<ServiceBillingDetail>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceBillingDetailActions.addServiceBillingDetail,
    (state, action) => adapter.addOne(action.serviceBillingDetail, state)
  ),
  on(ServiceBillingDetailActions.upsertServiceBillingDetail,
    (state, action) => adapter.upsertOne(action.serviceBillingDetail, state)
  ),
  on(ServiceBillingDetailActions.addServiceBillingDetails,
    (state, action) => adapter.addMany(action.serviceBillingDetails, state)
  ),
  on(ServiceBillingDetailActions.upsertServiceBillingDetails,
    (state, action) => adapter.upsertMany(action.serviceBillingDetails, state)
  ),
  on(ServiceBillingDetailActions.updateServiceBillingDetail,
    (state, action) => adapter.updateOne(action.serviceBillingDetail, state)
  ),
  on(ServiceBillingDetailActions.updateServiceBillingDetails,
    (state, action) => adapter.updateMany(action.serviceBillingDetails, state)
  ),
  on(ServiceBillingDetailActions.deleteServiceBillingDetail,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceBillingDetailActions.deleteServiceBillingDetails,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceBillingDetailActions.loadServiceBillingDetails,
    (state, action) => adapter.setAll(action.serviceBillingDetails, state)
  ),
  on(ServiceBillingDetailActions.clearServiceBillingDetails,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
